goog.require('el8.ext.onboarding.signupData');
goog.require('el8.service.tz');
goog.require('el8.template.print.baAgreement');
goog.require('el8.util.print');


var el8 = el8 || {};
if (!el8.main) { el8.main = {}; }
el8.main.printBaAgreement = {};


el8.main.printBaAgreement.init = function(spec) {

    el8.ext.onboarding.signupData.populate(spec.signup);

    $('.print-content').replaceWith(
        el8.template.print.baAgreement.content({
            today: el8.service.tz.today().asStringFormat('mmm ddd, yyyy'),
            providerName: el8.ext.onboarding.signupData.getFormalName()
        })
    );

    el8.util.print.pageSetup();
};

